import { Button, DialogActions, DialogContent, Grid } from '@mui/material'
import CustomerAccountsPaymentPanel from 'components/Sell/payment/dialogs/CustomerAccountsSellPopup/CustomerAccountsPaymentPanel'
import { useTranslation } from 'react-i18next'
import { CustomerAccountPaymentModel } from 'components/Sell/payment/dialogs/CustomerAccountsSellPopup/CustomerAccountsPaymentMobile'
import styles from 'components/Sell/payment/paymentDialog.style'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'

interface ICustomerAccountsPaymentMobileDialog {
    onCloseAccountDialog: () => void
    customerAccounts: CustomerAccountPaymentModel[]
    popupSelectCustomerId: string
    handleSelectCustomer: (customerId: string) => void
    onAssignToPayment: (customerID: string) => void
    selectedCustomer: CustomerAccountPaymentModel | undefined
    isLoading?: boolean
}

function CustomerAccountPaymentDialogContent({
    customerAccounts,
    popupSelectCustomerId,
    handleSelectCustomer,
    onAssignToPayment,
    selectedCustomer,
    onCloseAccountDialog,
    isLoading,
}: ICustomerAccountsPaymentMobileDialog) {
    const { t } = useTranslation()
    const { isMobile } = useScreenSize()
    return (
        <>
            <DialogContent>
                <CustomerAccountsPaymentPanel
                    customerAccounts={customerAccounts}
                    selectedCustomerId={popupSelectCustomerId}
                    onSelectCustomer={handleSelectCustomer}
                    onAssignToPayment={onAssignToPayment}
                    isLoading={isLoading}
                />
            </DialogContent>
            <DialogActions>
                <Grid container spacing={1} justifyContent={'space-between'}>
                    <Grid item xs={6} md="auto" lg="auto" xl="auto" sm="auto">
                        <Button
                            variant="outlined"
                            fullWidth={isMobile}
                            color="primary"
                            size={isMobile ? 'large' : undefined}
                            sx={styles.confirmButton}
                            onClick={onCloseAccountDialog}
                        >
                            Cancel
                        </Button>
                    </Grid>
                    <Grid item xs={6} md="auto" lg="auto" xl="auto" sm="auto">
                        <Button
                            disabled={!selectedCustomer}
                            className="textUpper"
                            fullWidth={isMobile}
                            color="primary"
                            size={isMobile ? 'large' : undefined}
                            sx={styles.confirmButton}
                            onClick={() =>
                                onAssignToPayment(popupSelectCustomerId)
                            }
                        >
                            {t('quick_sell.button.use_for_payment')}
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </>
    )
}
export default CustomerAccountPaymentDialogContent
